// extracted by mini-css-extract-plugin
export var icon = "_qw-0";